import { useEffect, useState } from "react";

const navItems = [
  { href: "#latest", label: "最新实锤" },
  { href: "#library", label: "证据库" },
  { href: "#timeline", label: "时间线拆解" },
  { href: "#standard", label: "核验标准" },
  { href: "#archive", label: "归档" },
  { href: "#about", label: "关于" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-[1200px] items-center justify-between gap-4 px-4 md:px-6">
        <h1 className="m-0">
          <a
            href="#top"
            className="flex items-center gap-2.5 whitespace-nowrap"
            aria-label="八酱黑料 首页"
          >
            <span className="flex h-9 w-9 items-center justify-center bg-primary-600 text-background-50">
              <i className="ri-shield-check-line flex h-5 w-5 items-center justify-center text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-bold tracking-tight text-foreground-950">
                八酱黑料
              </span>
              <span className="mt-1 text-[10px] font-medium tracking-[0.22em] text-primary-700">
                实锤证据挖掘
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((it) => (
            <a
              key={it.href}
              href={it.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 whitespace-nowrap transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {it.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <div className="hidden xl:flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2">
            <i className="ri-search-line flex h-4 w-4 items-center justify-center text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="检索材料、关键词…"
              aria-label="检索"
              className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <a
            href="#about"
            className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
          >
            <i className="ri-add-line flex h-4 w-4 items-center justify-center text-base" />
            提交线索
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-800 lg:hidden"
            aria-label="菜单"
            aria-expanded={open}
          >
            <i
              className={`flex h-5 w-5 items-center justify-center text-xl ${
                open ? "ri-close-line" : "ri-menu-line"
              }`}
            />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md px-4 py-3">
          <div className="flex flex-col gap-1">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200/70"
              >
                {it.label}
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-add-line text-base" />
              提交线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}